import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigurationService, SecurityService } from '../../services';


@Component({
    selector: 'login-page',
    templateUrl: 'login.page.html',
    styleUrls: ['login.page.scss'],
})
export class LoginPage implements OnInit {
    legacyAuthFailed: boolean = false;

    fintURL: string;

    constructor(
        private configurationService: ConfigurationService,
        private securityService: SecurityService,
        private router: Router) {
    }

    ngOnInit() { 
        this.fintURL = this.configurationService.getFintFMUrl();

        this.securityService.getLegacyToken()
            .subscribe(result => {
                if (result) {
                    this.router.navigate(['roster']);
                } else {
                    this.legacyAuthFailed = true;
                } 
            })
    }
}
